import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	model,
	OnInit,
	output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IRequester } from '@app/pages/cmms/interfaces/request.interfaces';
import { ContactsService } from '@app/pages/contacts/services/contacts.service';
import { getContactsList } from '@app/pages/contacts/state/contacts.selectors';
import { groupContacts } from '@app/pages/contacts/state/contacts.utils';
import { getCurrentBuilding } from '@app/pages/my-building/state/my-bulding.selectors';
import { AuPipesModule } from '@app/shared/pipes/au-pipes.module';
import { IAuComment } from '@app/shared/ui-components/au-comments/i-au.comment';
import { Store } from '@ngrx/store';

@Component({
	selector: 'cmms-autocomplete-contact',
	imports: [
		CommonModule,
		MatInputModule,
		MatFormFieldModule,
		MatAutocompleteModule,
		AuPipesModule,
		ReactiveFormsModule,
		MatIconModule,
		MatButtonModule,
	],
	templateUrl: './cmms-autocomplete-contact.component.html',
	styleUrl: './cmms-autocomplete-contact.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmmsAutocompleteContactComponent implements OnInit {
	readonly store$ = inject(Store);
	readonly contactsService = inject(ContactsService);

	editMode = model(false);
	comments = input<IAuComment[]>([]);
	placeholder = input('Requester');
	namePreviewClasses = input('');
	requestees = input([]);
	newRequesteeForm = input(false);
	allowEdit = input(true);
	controlReady = output<FormControl>();
	requesteesChanged = output<IRequester[]>();

	contactList = this.store$.selectSignal(getContactsList);
	contactGroup = computed(() => {
		return groupContacts(this.contactList(), 'location');
	});
	currentBuilding = this.store$.selectSignal(getCurrentBuilding);

	formControl = new FormControl('');
	formContact = new FormControl(null);

	autoGenerated = computed(() => {
		return (
			this.comments().length > 0 &&
			this.comments()[this.comments().length - 1].author.displayName === 'Autility System'
		);
	});

	hasValidValue = computed(() => !!this.requestees()?.[0]?.email);

	ngOnInit(): void {
		this.contactsService.handleContacts(this.currentBuilding()?.locationId);
		this.controlReady.emit(this.formContact);

		this.formControl.valueChanges.subscribe((value: any | null) => {
			if (!value) {
				return;
			}
			if (value.email) {
				this.formContact.setValue({
					email: value.email,
					name: `${value.firstName} ${value.lastName}`,
				});
				this.formControl.setValue(value.email);
				return;
			}

			this.formContact.setValue({ email: value, name: value });
		});
	}

	requesteeChanged(): void {
		if (this.newRequesteeForm()) {
			return;
		}
		this.editMode.set(false);

		if (this.formContact.value?.email) {
			this.requesteesChanged.emit([this.formContact.value]);
			this.formControl.reset();
		}
	}
}
